import { Fragment, useContext, useMemo } from 'react';
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import { makeStyles } from 'tss-react/mui';
import MenuItem from './menuItem';
import { AuthContext } from '../../../context/auth';
import People from '@mui/icons-material/People';
import DashboardIcon from '@mui/icons-material/Dashboard';
import BadgeIcon from '@mui/icons-material/Badge';
import ApartmentIcon from '@mui/icons-material/Apartment';

const useStyles = makeStyles()((theme) => ({
    container: {
        overflow: "hidden auto",
        margin: "8px 0",
    },
    headerExpandible: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundImage: "linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05))",
        paddingLeft: "55px",
    },
    divider: {
        margin: "8px 0",
    }
}));

export default function Main() {
    const { usuario } = useContext(AuthContext);
    const { classes } = useStyles();

    const isAdminVisible = useMemo(() => {
        if (!usuario) return false;
        return usuario.nivel_usuario === 1 || usuario.sup_usuarios === true;
    }, [usuario]);

    const isUsuariosDisabled = useMemo(() => {
        if (!usuario) return true;
        return !(usuario.nivel_usuario === 1 || usuario.sup_usuarios === true);
    }, [usuario]);

    const canPersonal = useMemo(() => {
        if (!usuario) return false;
        return usuario.nivel_usuario === 1 || usuario.sup_personal === true;
    }, [usuario]);

    const canAreas = useMemo(() => {
        if (!usuario) return false;
        return usuario.nivel_usuario === 1 || usuario.sup_areas === true;
    }, [usuario]);

    const isRrhhVisible = useMemo(() => canPersonal || canAreas, [canPersonal, canAreas]);

    const menuItems = [
        {
            label: "Inicio",
            visible: !!usuario,
            items: [
                {
                    label: "Panel de Inicio",
                    icon: DashboardIcon,
                    url: "/dashboard",
                    visible: true,
                    disabled: false,
                    list: []
                },
            ],
        },
        {
            label: "Recursos Humanos",
            visible: isRrhhVisible,
            items: [
                {
                    label: "Personal",
                    icon: BadgeIcon,
                    url: "/personal",
                    visible: canPersonal,
                    disabled: !canPersonal,
                    list: []
                },
                {
                    label: "Áreas (CUOF)",
                    icon: ApartmentIcon,
                    url: "/area",
                    visible: canAreas,
                    disabled: !canAreas,
                    list: []
                },
            ],
        },
        {
            label: "Administración",
            visible: isAdminVisible,
            items: [
                {
                    label: "Usuarios",
                    icon: People,
                    url: "/usuario",
                    visible: true,
                    disabled: isUsuariosDisabled,
                    list: []
                },
            ],
        },
    ];

    return (
        <div className={classes.container}>
            { menuItems.map((seccion) => (
                seccion.visible ?
                    <Fragment key={`seccion-${seccion.label}`}>
                        <ListSubheader inset className={classes.headerExpandible}> {seccion.label} </ListSubheader>

                        {seccion.items.map((item) => (
                            item.visible ?
                                <Fragment key={`item-${item.url || item.label}`}>
                                    <MenuItem url={item.url} label={item.label} Icon={item.icon} disabled={item.disabled} />
                                    <List component="div" disablePadding>
                                        { item.list.map((subitem) => (
                                            subitem.visible ?
                                                <MenuItem
                                                    key={`subitem-${(item.url || '') + (subitem.url || subitem.label)}`}
                                                    url={(item.url || '') + (subitem.url || '')}
                                                    label={subitem.label}
                                                    Icon={subitem.icon}
                                                    disabled={subitem.disabled}
                                                    sx={{ pl: 7 }}
                                                />
                                            : null
                                        ))}
                                    </List>
                                </Fragment>
                            : null
                        ))}
                    </Fragment>
                : null
            ))}
        </div >
    );
}
